import { render, staticRenderFns } from "./MpsUsage.vue?vue&type=template&id=c08dbb9e&scoped=true"
import script from "./MpsUsage.vue?vue&type=script&lang=js"
export * from "./MpsUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08dbb9e",
  null
  
)

export default component.exports